module.exports = __webpack_public_path__ + "static/media/legal.a701d5dc.svg";